import _ from 'lodash'
export default function verifyEmail(state = [], action) {
  const newState = _.cloneDeep(state)
  switch (action.type) {
    case 'VERIFY_REQ_SUCCESS':
      return Object.assign({}, newState, { success: action.data.success, message: action.data.message })
    case 'VERIFY_REQ_RESET':
      return Object.assign({}, newState, {...state, message: '' })
    case 'VERIFY_REQ_FAIL':
      return Object.assign({}, newState, { message: action.error, success: false })
    default:
      return newState
  }
}
